import { useDispatch, useSelector } from 'react-redux'

import Button from '@/components/form/Button'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { Translation } from '@/components/i18n/Translation'
import { closePopup } from '@/ducks/popupReducer'
import { addProduct, createProductSelection, setPaymentType } from '@/ducks/shopOrderReducer'
import { getProductFromId } from '@/ducks/shopProductsReducer'
import { PAYMENT_TYPES } from '@/util/shop'

import './product-add-dialog.scss'

const ProductAddDialog = ({ productId }: any) => {
  const { leasing_duration_months, leasing_price, buying_price } =
    useSelector(state => getProductFromId(state, productId)) ?? {}
  const dispatch = useDispatch()

  const productSelection = createProductSelection({
    productId: productId,
    amount: 1,
  })

  const onConfirm = (isLeasing: boolean) => {
    dispatch(setPaymentType(isLeasing ? PAYMENT_TYPES.LEASE : PAYMENT_TYPES.BUY))
    dispatch(addProduct(productSelection))
    dispatch(closePopup())
  }

  return (
    <div className="product-add-dialog">
      <h2>
        <Translation id="Select payment type" />
      </h2>

      <p>
        <Translation id="How do you wish to finance this order?" />
      </p>

      <div className="button-spread">
        <div className="payment-option lease">
          <p className="total-cost">
            <FormattedNumberWithCurrency amount={leasing_price} />
          </p>

          <Button onClick={() => onConfirm(true)}>
            <Translation id="I want to lease" />
          </Button>

          <p className="leasing-cost-monthly">
            <Translation
              id="{m} monthly for {n} months"
              m={<FormattedNumberWithCurrency amount={leasing_price / leasing_duration_months} />}
              n={leasing_duration_months}
            />
          </p>
        </div>

        <div className="payment-option buy">
          <p className="total-cost">
            <FormattedNumberWithCurrency amount={buying_price} />
          </p>

          <Button onClick={() => onConfirm(false)}>
            <Translation id="I want to buy" />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ProductAddDialog
